<template>
  <div>
    <Breadcrumb :style="{ margin: '20px 10px' }">
      <BreadcrumbItem>礼品卡管理</BreadcrumbItem>
      <BreadcrumbItem>礼品卡列表</BreadcrumbItem>
    </Breadcrumb>
    <loading :loading="loading" :error="error"></loading>
    <Form ref="selectForm" :model="selectForm" inline>
      <FormItem prop="gift_card_asn">
        <Input v-model="selectForm.gift_card_asn" placeholder="礼品券编号"></Input>
      </FormItem>
      <FormItem prop="templet_no">
        <Input v-model="selectForm.templet_no" placeholder="模板编号"></Input>
      </FormItem>
      <FormItem prop="category_id">
        <Select
            v-model="selectForm.category_id"
            clearable
            multiple
            filterable
            style="width: 250px; margin-right: 10px; margin-left: 10px"
            @on-query-change="handleInput"
            @on-change="handleSelectChange"
            ref="select"
        >
          <Option
              v-for="category in categories"
              :value="category.category_id"
              :key="category.category_id"
          >{{ category.title }}</Option
          >
        </Select>
      </FormItem>
      <FormItem prop="status">
        <Select
            v-model="selectForm.status"
            clearable
            placeholder="请选择状态"
            style="width: 150px; margin-right: 10px"
        >
          <Option value="0">未发送</Option>
          <Option value="1">已占用</Option>
          <Option value="2">已发送</Option>
          <Option value="3">已核销</Option>
          <Option value="4">异常</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('selectForm')">查询</Button>
<!--        <Button type="primary" @click="goExportII()" style="margin-left: 5px;">导出</Button>-->
      </FormItem>
    </Form>
    <Table border stripe :columns="columns1" :data="list">
      <template slot-scope="{ row }" slot="status">
        <span v-if="row.status === 0">未发送</span>
        <span v-else-if="row.status === 1">已占用</span>
        <span v-else-if="row.status === 2">已发送</span>
        <span v-else-if="row.status === 3">已核销</span>
        <span v-else-if="row.status === 4">异常</span>
        <span v-else>-</span>
      </template>
      <template slot-scope="{ row }" slot="card_status">
        <span v-if="row.card_status === 2">正常</span>
        <span v-else-if="row.card_status === 3">绑定</span>
        <span v-else-if="row.card_status === 5">派发</span>
        <span v-else>-</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" size="small" style="margin: 5px" @click="orders(row,index)">订单</Button>
      </template>
    </Table>
    <expandRow style="display: none"></expandRow>
    <Page style="margin: 10px; text-align:center;" @on-change="pageOnChange" :total="pages.total" :page-size="pages.per_page" show-elevator prev-text="上一页" next-text="下一页" />
  </div>
</template>

<script>
import expandRow from "../member-1/coupon_expand";
import loading from "../loading";

export default {
  components: { expandRow, loading },
  name: "card_list",
  data () {
    return {
      loading: false,
      error: null,
      list: [],
      selectForm: {
        category_id: '',
        templet_no: '',
        status: '',
        gift_card_asn: '',
      },
      categories: null,
      pages: {},
      columns1: [
        // {
        //   type: 'expand',
        //   width: 50,
        //   render: (h, params) => {
        //     let order = params.row.coupons_code;
        //     return h(expandRow, {
        //       props: {
        //         row: order
        //       }
        //     })
        //   }
        // },
        { align: "center", title: '礼品券编号', key: 'gift_card_asn', minWidth: 100 },
        { align: "center", title: '编码', key: 'category_id', minWidth: 100 },
        { align: "center", title: '模板编号', key: 'templet_no', minWidth: 100 },
        { align: "center", title: '模板名称', key: 'templet_name', minWidth: 100 },
        { align: "center", title: '采购订单号', key: 'order_no', minWidth: 100 },
        { align: "center", title: '面额（元）', key: 'face_value', minWidth: 80 },
        { align: "center", title: '状态', slot: 'status', minWidth: 80 },
        { align: "center", title: '券状态', slot: 'card_status', minWidth: 80 },
        { align: "center", title: '操作', slot: 'action', width: 150 }
      ],
    }
  },
  created () {
    this.fetchData('giftCard/list', this.$route.query);
    this.axios.get("couponCategories/giftTotalList").then((res) => {
      console.log("res", res);
      this.categories = res.data.coupon_categories;
      this.loading = false;
    });
  },
  methods: {
    handleInput(e) {
      this.lastSearchQuery = e;
    },
    handleSelectChange() {
      let input = this.lastSearchQuery;
      setTimeout(() => {
        this.$refs.select.setQuery(input);
      }, 300);
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.fetchData('giftCard/list', this.selectForm);
        } else {
          this.$Message.error('出错了');
        }
      })
    },
    pageOnChange: function (page) {
      console.log('page=>', page);
      let url = 'giftCard/list?page=' + page;
      this.fetchData(url, this.selectForm);
    },
    fetchData: function (url, param) {
      let data = {};
      for (let key in param) {
        console.log('param[key],', param[key]);
        if (param[key] === undefined || param[key].length == 0) {
          delete param[key];
        }
      }
      data.params = param;
      this.loading = true;
      this.axios.get(url, data).then(res => {
        this.list = res.data.gift_card;
        this.list.forEach(element => {
          element._expanded = false;
        });
        this.pages = res.data.meta;
        this.loading = false;
      })
    },
    orders(row, index) {
      console.log("row=>", row.id);
      console.log("index=>", index);
      // let params = this.selectForm;
      // params.page = this.pages.current_page;
      this.$router.push("/pages/gift_card_orders?gift_card_asn=" + row.gift_card_asn);
      // this.$router.push({
      //   path: "/pages/gift_card_orders/" + row.gift_card_asn,
      //   query: params,
      // });
    },
  }
}
</script>

<style scoped>

</style>